const KITCHEN_SESSION_KEY = 'superoti.kitchen.session'

export type KitchenSession = {
  accessToken: string
  userId: string
  userName: string
  role: 'HEAD_KITCHEN' | 'ASSISTANT_HEAD_KITCHEN' | 'STAFF_KITCHEN'
  authority: 'full' | 'attendance_only'
  head_present: boolean
  loggedInAt: string
}

export function getKitchenSession(): KitchenSession | null {
  try {
    const raw = localStorage.getItem(KITCHEN_SESSION_KEY)
    if (!raw) return null
    return JSON.parse(raw) as KitchenSession
  } catch {
    return null
  }
}

export function hasKitchenSession(): boolean {
  return getKitchenSession() !== null
}

export function setKitchenSession(session: KitchenSession): void {
  localStorage.setItem(KITCHEN_SESSION_KEY, JSON.stringify(session))
}

export function updateKitchenSessionAuthority(
  authority: KitchenSession['authority'],
  head_present: KitchenSession['head_present'],
): void {
  const session = getKitchenSession()
  if (!session) return
  setKitchenSession({ ...session, authority, head_present })
}

export function clearKitchenSession(): void {
  localStorage.removeItem(KITCHEN_SESSION_KEY)
}
